import React, { ReactNode } from 'react';

type ContentProps = {
    className?: string;
    children: ReactNode;
}

const SectionContent = ({ className = '', children }: ContentProps) => {
    return (
        <div className={`${className ? ' ' + className : ''}`}>
            {children}
        </div>
    );
};

export default SectionContent;
